import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";


import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import * as APIS from "../utils/service";

export default function AddrSelector(props) {

    const { 
        setcityspopflag=()=>{},
        listselecterviewerlist=[], 
        setlistselecterviewerlist=()=>{},
    } = props;


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [sidoArr, setsidoArr] = useState([]);   
    const [sigunguArr, setsigunguArr] = useState([]);   
    const [dongArr, setdongArr] = useState([]);   
    const [selsido, setselsido] = useState('');   
    const [selsigungu, setselsigungu] = useState('');   
    const [seldong, setseldong] = useState('');   


    useEffect(() => {
        APIS.postData('/sido').then(({ data }) => {
            //console.log(data?.loading_img);
            setsidoArr(data);
        }).catch((e) => {
        }).finally(() => {
        });
    }, []);
    const sigunguGet = (sido) => {
        APIS.postData('/sigungu', {sido: sido}).then(({ data }) => {
            //console.log(data?.loading_img);
            setsigunguArr(data);
        }).catch((e) => {
        }).finally(() => {
        });
    }
    const dongGet = (sigungu) => {
        APIS.postData('/dong', {sido: selsido, sigungu: sigungu}).then(({ data }) => {
            //console.log(data?.loading_img);
            setdongArr(data);
        }).catch((e) => {
        }).finally(() => {
        });
    }
    
    return (
        <>
            <div className="addrlists ">
                <div>
                    <div>시/도</div>
                    <div>시/군/구</div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>읍/면/동</div>
                </div>
                <div>
                    <div>
                        {sidoArr?.length > 0 && sidoArr?.map((x, i) => {
                            return (
                                <div key={i}>
                                    <Button buttonTxt={x} className={`addrlistsbutton ${selsido === x ? 'active' : ''}`} 
                                        onPress={() => { 
                                            setselsido(x); 
                                            sigunguGet(x);
                                        }} 
                                    />
                                </div>
                            );
                        })}
                    </div>
                    <div>
                        {sigunguArr?.map((x, i) => {
                            return (
                                <div key={i}>
                                    <Button 
                                        buttonTxt={x} className={`addrlistsbutton ${selsigungu === x ? 'active' : ''}`} 
                                        onPress={() => {
                                            setselsigungu(x);
                                            dongGet(x);
                                        }} 
                                    />
                                </div>
                            );
                        })}
                    </div>
                    <div>
                        {dongArr?.length > 0 &&
                        <div >
                            <Button 
                                styles={{ width: 125 }}
                                titleimgs={`${listselecterviewerlist?.find(item => item?.viewernames === selsigungu+" 전체") ? './images/icons/fa6-solid_check.svg' : ''}`}
                                buttonTxt={`${selsigungu} 전체`} 
                                className={`addrlistsbutton ${listselecterviewerlist?.find(item => item?.viewernames === selsigungu+" 전체") ? 'active' : ''}`} 
                                onPress={() => {
                                    setseldong(selsigungu+" 전체");
                                    if(listselecterviewerlist?.find(item => item?.viewernames === selsigungu+" 전체")){
                                        setlistselecterviewerlist(listselecterviewerlist?.filter(item => item?.viewernames !== selsigungu+" 전체"));
                                    } else {
                                        // setlistselecterviewerlist([...listselecterviewerlist, {viewernames: selsigungu+" 전체", sido: selsido, sigungu: selsigungu}]);
                                        //전체일경우에는 하위 지역들 삭제
                                        const filterData = listselecterviewerlist?.filter(v => !(v.sido === selsido && v.sigungu === selsigungu))
                                        setlistselecterviewerlist([...filterData, {viewernames: selsigungu+" 전체", sido: selsido, sigungu: selsigungu}]);
                                    }
                                }} 
                            />
                        </div>
                        }       
                        {dongArr?.map((x, i) => {
                            return (
                                <div key={i}>
                                    <Button 
                                        styles={{ width: 125 }}
                                        titleimgs={`${listselecterviewerlist?.find(item => item?.viewernames === x) ? './images/icons/fa6-solid_check.svg' : ''}`}
                                        buttonTxt={x} className={`addrlistsbutton ${listselecterviewerlist?.find(item => item?.viewernames === x) ? 'active' : ''}`} 
                                        onPress={() => {
                                            setseldong(x);
                                            if(listselecterviewerlist?.find(item => item?.viewernames === x)){
                                                setlistselecterviewerlist(listselecterviewerlist?.filter(item => item?.viewernames !== x));
                                            } else {
                                                if(listselecterviewerlist.find(item=>item?.viewernames ===  selsigungu+" 전체")){
                                                    // 전체가 있을경우 전체를 제거하고 선택한것으로 처리
                                                    setlistselecterviewerlist(list =>{
                                                        list = list?.filter(item => item?.viewernames !== selsigungu+" 전체")
                                                        return [...list, {viewernames: x, sido: selsido, sigungu: selsigungu}]
                                                    });
                                                }else{
                                                    setlistselecterviewerlist([...listselecterviewerlist, {viewernames: x, sido: selsido, sigungu: selsigungu}]);
                                                }
                                            }                                            
                                        }} 
                                    />
                                </div>
                            );
                        })}
                    </div>                                                
                </div>
            </div>
        </>
    )    
}